export default class PostContractMeterRequest {
    constructor(
        public meter_id: number,
        public contract_id: string,
        public description: string,
        public value: number,
        public force: boolean
    ) {}
}